import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { useThemeColorMeta } from '@trellis/roots/lib/useThemeColorMeta'
import { lazy, Suspense } from 'react'
import { Toaster } from 'sonner'

import { env } from '@/env'

export interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
})

const TanStackRouterDevtools =
  import.meta.env.DEV && env.VITE_SHOW_ROUTER_DEVTOOLS
    ? lazy(() =>
        import('@tanstack/react-router-devtools').then((routerDevtools) => ({
          default: routerDevtools.TanStackRouterDevtools,
        })),
      )
    : () => null

function RootLayout() {
  useThemeColorMeta()

  return (
    <>
      <Toaster richColors />
      <Outlet />
      <Suspense fallback={null}>
        <TanStackRouterDevtools position="bottom-right" />
      </Suspense>
    </>
  )
}
